{
  "siteTitle": "Beheerdersportaal",
  "actions": {
    "search": "Zoeken",
    "view": "Bekijken",
    "add": "Toevoegen",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "save": "Opslaan",
    "continue": "Doorgaan",
    "submit": "Indienen",
    "apply": "Toepassen",
    "loadMore": "Meer laden",
    "logout": "Uitloggen",
    "reload": "Verversen",
    "back": "Terug",
    "next": "Volgende",
    "retry": "Opnieuw starten"
  },
  "menuGroups": {
    "company": "Mijn bedrijf",
    "account": "Account gegevens",
    "debitRoom": "DebitRoom"
  },
  "errors": {
    "titles": {
      "500": "Er ging iets mis",
      "429": "Te veel verzoeken",
      "422": "Je hebt iets niet juist ingevuld.",
      "404": "Niet gevonden",
      "403": "Geen toegang",
      "network": "Netwerkfout"
    },
    "messages": {
      "500": "Er ging iets onbekends mis, we hebben een melding gemaakt van het probleem. Probeer het later opnieuw.",
      "429": "Je hebt te veel verzoeken gedaan. Probeer het opnieuw over {seconds} seconden.",
      "422": "Je hebt iets niet juist ingevuld.",
      "404": "Niet gevonden",
      "403": "Je hebt geen toegang tot dit onderdeel.",
      "network": "Er is een netwerkfout opgetreden. Dit betekent waarschijnlijk dat je geen verbinding hebt met het internet, probeer het later opnieuw."
    },
    "validation": {
      "mongoId": "{0} is verplicht",
      "required": "{0} is verplicht",
      "alpha": "{0} mag alleen letters bevatten",
      "equals": "{0} moet gelijk zijn aan {1}",
      "notEquals": "{0} mag niet gelijk zijn aan {1}",
      "empty": "{0} moet leeg zijn",
      "notEmpty": "{0} mag niet leeg zijn",
      "in": "{0} moet een van de volgende waarden zijn: {1}",
      "notIn": "{0} mag niet een van de volgende waarden zijn: {1}",
      "boolean": "{0} moet een ja of nee zijn",
      "date": "{0} is verplicht",
      "string": "{0} is verplicht",
      "number": "{0} is verplicht",
      "int": "{0} moet een geheel getal zijn",
      "array": "{0} moet een lijst zijn",
      "enum": "{0} moet een van de volgende waarden zijn: {1}",
      "divisibleBy": "{0} moet deelbaar zijn door {1}",
      "positive": "{0} moet positief zijn",
      "negative": "{0} moet negatief zijn",
      "min": "{0} mag niet kleiner zijn dan {1}",
      "minLength": "{0} moet langer zijn dan {1} karakter",
      "max": "{0} mag niet groter zijn dan {1}",
      "length": "{0} moet exact {1} tekens lang zijn",
      "minDate": "{0} moet na {1} zijn",
      "maxDate": "{0} mag niet voor {1} zijn",
      "booleanString": "{0} moet een tekstuele waarde van ja of nee zijn",
      "dateString": "{0} is verplicht",
      "numberString": "{0} mag enkel uit nummers bestaan",
      "iBAN": "{0} is geen geldig IBAN nummer",
      "email": "{0} is geen geldig e-mailadres",
      "phoneNumber": "{0} is geen geldig telefoonnummer",
      "strongPassword": "{0} moet een sterk wachtwoord zijn",
      "postalCode": "Dit is geen geldige postcode",
      "unique": "{0} is al in gebruik",
      "before": "{0} moet voor {1} zijn",
      "pattern": "{0} voldoet niet aan het patroon",
      "bIC": "{0} is geen geldig BIC nummer",
      "personName": "{0} is geen geldige naam",
      "inArray": "{0} is niet toegestaan",
      "after": "{0} moet na {1} zijn"
    }
  },
  "titles": {
    "confirmationDialog": "Weet je het zeker?"
  },
  "messages": {
    "none": "geen",
    "welcome": "Welkom",
    "createdAtBy": "Aangemaakt op {date} door {name}",
    "updatedAtBy": "Laatst gewijzigd op {date} door {name}",
    "confirmationDialog": "Weet je zeker dat je deze actie wilt uitvoeren? Dit is niet terug te draaien."
  },
  "fields": {
    "labels": {
      "address": {
        "street": "Straat",
        "houseNumber": "Huisnummer",
        "postalCode": "Postcode",
        "city": "Plaats",
        "country": "Land"
      }
    }
  },
  "labels": {
    "actions": "Acties"
  },
  "units": {
    "months": "{n} maand|{n} maanden",
    "years": "{n} jaar|{n} jaren",
    "days": "{n} dag|{n} dagen"
  },
  "and": "en",
  "unknown": "Onbekend",
  "yes": "Ja",
  "no": "Nee"
}
